module.exports = __webpack_public_path__ + "static/media/AwesomeProfileCards_cover.815577ba.png";